"use strict";
import R from "ramda";
import Redaction from "../redaction_element";
import Stamp from "../stamp_element";
import Crop from "../crop_element";
import TextAnnotation from "../text_element";
const VIEWS = [Redaction, Stamp, Crop, TextAnnotation];
function toKVPair(component) {
  return [component.typeID, component];
}
export default R.pipe(R.map(toKVPair), R.fromPairs)(VIEWS);
